import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { IQueryParams } from "queries";
import helpers from "helpers/index";
import queryClient from 'queries';

/**
*   Interface/model file auto generate for Setting Group
*   Interface for back-end
*   Model for front-end.
*   They are the same!
*/
export interface TypedApp {
    ID?: string;
    app_thumbnail?: string;
    app_name?: string;
    app_description?: string;
    app_type?: string;
    app_slug?: string;
    app_homepage?: string;
    client_private_key?: string;
    client_public_key?: string;
    status?: number;
    createdAt?: any;
}


type IQuery = TypedApp & IQueryParams;


/*
* List of all app
*/
export function useGetApps(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["app/fetch_entity_list"],
        queryFn: () => axios.get<TypedApp[]>(`/app${EndURL}`).then(response => {
            let { data, headers } = response;
            return {
                entities: data,
                totalItems: Number(headers['x-total-count'] || 0)
            }
        }),
        retry: 1,
        refetchOnWindowFocus: false,
        enabled: true,
    });
}



export function useGetApp(app_id: string) {
    return useQuery({
        queryKey: ['app/fetch_entity'],
        queryFn: () => axios.get<TypedApp>(`/app/${app_id}`).then((response) => response.data),
        retry: 1,
        refetchOnWindowFocus: false,
        // enabled: false,
    });
}


export function useUpdateApp() {
    return useMutation({
        mutationKey: ['app/update_entity'],
        mutationFn: ({ ID, ...rest }: TypedApp) => axios.patch<TypedApp>(`/app/${ID}`, helpers.cleanEntity(rest)).then((response) => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['app/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['app/fetch_entity'] });
        }
    });
}


export function useCreateApp() {
    return useMutation({
        mutationKey: ['app/create_entity'],
        mutationFn: (entity: TypedApp) => axios.post<TypedApp>(`/app`, helpers.cleanEntity(entity)).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['app/fetch_entity_list'] });
        }
    });
}


export function useDeleteApp() {
    return useMutation({
        mutationKey: ['app/delete_entity'],
        mutationFn: (app_id: string) => axios.delete<any>(`/app/${app_id}`),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['app/fetch_entity_list'] });
        }

    });
}


export function useGenerateNewClientPublicKey() {
    return useMutation({
        mutationKey: ['app/create_new_client_public_key'],
        mutationFn: (app_id: string) => axios.patch<any>(`/app/client_public_key/${app_id}`),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['app/fetch_entity'] });
        }
    });
}